export default "__VITE_ASSET__qTukvnu___"